Template.loginForm.events({
    'submit #login-form': function(event) {
      event.preventDefault();
      var emailVar = event.target.username.value;
      var passwordVar = event.target.password.value;
      Meteor.loginWithPassword(emailVar, passwordVar, function(err) {
        if (err) {
            alert(err);
        }
    });
    }
});
